import type { TranslatableFieldSpec } from "./translation-field-editors";

export type TranslationEditorKind = "single-line" | "multiline" | "html";

export function translationEditorKind(
  field: TranslatableFieldSpec,
): TranslationEditorKind {
  if (field.kind === "html") {
    return "html";
  }
  return field.multiline ? "multiline" : "single-line";
}
